"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _propTypes = _interopRequireDefault(require("prop-types"));

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        (0, _defineProperty2["default"])(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

var styleTypes = {
  style: _propTypes["default"].object,
  contentStyle: _propTypes["default"].object,
  inputAreaStyle: _propTypes["default"].object,
  promptLabelStyle: _propTypes["default"].object,
  inputStyle: _propTypes["default"].object
};
var classNameTypes = {
  className: _propTypes["default"].string,
  contentClassName: _propTypes["default"].string,
  inputAreaClassName: _propTypes["default"].string,
  promptLabelClassName: _propTypes["default"].string,
  inputClassName: _propTypes["default"].string
};
var optionTypes = {
  autoFocus: _propTypes["default"].bool,
  dangerMode: _propTypes["default"].bool,
  disableOnProcess: _propTypes["default"].bool,
  noDefaults: _propTypes["default"].bool,
  noAutomaticStdout: _propTypes["default"].bool,
  noHistory: _propTypes["default"].bool,
  noAutoScroll: _propTypes["default"].bool
};
var labelTypes = {
  welcomeMessage: _propTypes["default"].oneOfType([_propTypes["default"].bool, _propTypes["default"].array, _propTypes["default"].string]),
  promptLabel: _propTypes["default"].string,
  errorText: _propTypes["default"].string
};
var commandTypes = {
  commands: _propTypes["default"].object.isRequired,
  commandCallback: _propTypes["default"].func
};

var _default = _objectSpread({}, styleTypes, {}, classNameTypes, {}, optionTypes, {}, labelTypes, {}, commandTypes);

exports["default"] = _default;